var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNotifIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_605_28392)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.9997 23.3534C12.4196 23.3437 12.8226 23.1858 13.1374 22.9077C13.4522 22.6295 13.6584 22.249 13.7197 21.8334H10.213C10.276 22.2602 10.4919 22.6497 10.8205 22.9293C11.1492 23.2089 11.5682 23.3596 11.9997 23.3534Z",
    fill: "#666666"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.8996 19.2534L21.673 19.0534C21.0299 18.4804 20.4671 17.8234 19.9996 17.1C19.4891 16.1017 19.1831 15.0115 19.0996 13.8934V10.6C19.0969 10.2 19.0612 9.80086 18.993 9.40668C17.8637 9.17458 16.8493 8.55936 16.1216 7.6652C15.3939 6.77104 14.9975 5.65288 14.9996 4.50002V4.08002C14.3036 3.73748 13.5557 3.51222 12.7863 3.41335V2.57335C12.7863 2.33731 12.6925 2.11093 12.5256 1.94402C12.3587 1.77712 12.1323 1.68335 11.8963 1.68335C11.6602 1.68335 11.4339 1.77712 11.267 1.94402C11.1001 2.11093 11.0063 2.33731 11.0063 2.57335V3.44668C9.28344 3.68972 7.70668 4.54785 6.56711 5.86264C5.42754 7.17743 4.80211 8.86011 4.80629 10.6V13.8934C4.7228 15.0115 4.41681 16.1017 3.90629 17.1C3.44688 17.8216 2.89309 18.4785 2.25963 19.0534L2.03296 19.2534V21.1334H21.8996V19.2534Z",
    fill: "#666666"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9996 7.83341C21.8405 7.83341 23.3329 6.34103 23.3329 4.50008C23.3329 2.65913 21.8405 1.16675 19.9996 1.16675C18.1586 1.16675 16.6663 2.65913 16.6663 4.50008C16.6663 6.34103 18.1586 7.83341 19.9996 7.83341Z",
    fill: "#299D91"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_605_28392"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotifIcon);
export default __webpack_public_path__ + "static/media/notif-icon.0755d1e11ab0873b76d91229e90eee92.svg";
export { ForwardRef as ReactComponent };